import { render } from "./EnlargeSvg.vue?vue&type=template&id=7dffd7ce&bindings={}"
import script from "./EnlargeSvg.vue?vue&type=script&lang=ts"
export * from "./EnlargeSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script